import { Component } from '@angular/core';
import { Subscription } from '../data/subscription';
import { FordService } from '../services/ford.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Dealer, DealerCurrent } from '../data/dealer';
import { FuncsService } from '../services/funcs.service';
import { DealerService } from '../services/dealer.service';

@Component({
  selector: 'app-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.css'],
  standalone: false
})
export class CancelComponent {
  dealer: Dealer = DealerCurrent;

  constructor(
    private fordService: FordService,
    private dealerService: DealerService,
    private funcs: FuncsService,
    private _router: Router,
    private route: ActivatedRoute
  ) { }

  sub: Subscription = {
    createdAt: "",
    startDate: "",
    siteCode: "3333",
    maxAllowedUniqueDealerTechnicianLogins: 119,
    concurrentSessions: 12,
    expiresAt: "",
    status: 0
  };

  subscribed: boolean = false;
  public enrolled = "";
  tech_count: number = 0;
  ref: any;
  fleet: boolean = false;

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      this.ref = queryParams.get('ref');
      if (this.ref == "fleet") {
        this.fleet = true;
      }
    });
    this.funcs.currentDealer(this.dealer);
    this.getSubscription();
  }

  getSubscription(): void {
    this.fordService.getSubscription(`${this.dealer.pa_code}`).subscribe(sub => {
      this.sub = sub;
      // this.sub.maxAllowedUniqueDealerTechnicianLogins = sub.maxAllowedUniqueDealerTechnicianLogins;

      // console.log(sub);

      this.subscribed = this.funcs.isSubscribed(sub);

      if (!this.subscribed && this.funcs.getThreeLetterCountry(sub.siteCode) === 'USA' || this.funcs.getThreeLetterCountry(sub.siteCode) === 'CAN') {
        // get our tech count
        this.dealerService.getDealer(this.funcs.stripCountry(sub.siteCode)).subscribe(d => {
          this.tech_count = d.tech_count;
        });
      } else {
        this.tech_count = sub.maxAllowedUniqueDealerTechnicianLogins;
      }
      this.enrolled = new Date(this.sub.createdAt).toDateString();
    });
  }

  cancelSubscription(): void {
    // var dealerCode = DealerCurrent.pa_code;
    // this.fordService.deleteSubscription(dealerCode).subscribe(
    //   () => this._router.navigateByUrl('/status-enrolled')
    // );

    var now = new Date();

    // make expires the last day of the month
    var expires = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
    // expires.setFullYear(expires.getFullYear() + 100); // 100 years from now
    this.sub.expiresAt = expires.toISOString();
    // this.sub.expiresAt = expires;

    // this.sub.expiresAt = (new Date()).toISOString();
    this.sub.startDate = (new Date(0)).toISOString();
    if (!this.sub.createdAt) {
      this.sub.createdAt = (new Date()).toISOString();
    }

    // console.log(this.sub);

    this.fordService.addSubscription(this.sub).subscribe(response => {
      if (this.fleet) {
        this._router.navigate(['/status-enrolled'], {
          queryParams: { ref: 'fleet' },
        });
      } else {
        this._router.navigateByUrl('/status-enrolled')
      }
    });
  }
}
